module.exports = __webpack_public_path__ + "static/img/topmiddle.a92b8a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/topmiddle.png
// module id = hX1W
// module chunks = 1